/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsApiErrorResponseSchema } from "./goodLuck/core/DTOs/apiErrorResponseSchema.ts";
import { goodLuckCoreDTOsTokenResponseDtoSchema } from "./goodLuck/core/DTOs/tokenResponseDtoSchema.ts";
import { z } from "zod/v4";

export const postTeamsIdInviteRegeneratePathParamsSchema = z.object({
  id: z.string(),
});

/**
 * @description OK
 */
export const postTeamsIdInviteRegenerate200Schema = z.lazy(
  () => goodLuckCoreDTOsTokenResponseDtoSchema,
);

/**
 * @description Unauthorized
 */
export const postTeamsIdInviteRegenerate401Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Forbidden
 */
export const postTeamsIdInviteRegenerate403Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Not Found
 */
export const postTeamsIdInviteRegenerate404Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Internal Server Error
 */
export const postTeamsIdInviteRegenerate500Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

export const postTeamsIdInviteRegenerateMutationResponseSchema =
  postTeamsIdInviteRegenerate200Schema;
